
export const version = '3.1.0';
export const packageId = 'kentico-cloud-delivery-typescript-sdk';
export const repoHost = 'npmjs.com'
